import axios from 'axios';

export const HTTP = axios.create({

  baseURL: process.env.REACT_APP_API_BASE_URL,
  // baseURL: "https://apisandbox.dev.clover.com",
  // baseURL: "http://localhost:8000",
  headers: {
    'accept': 'application/json',
    'Content-Type': 'application/json',
  }
});